export enum ProcedureRequestActions {
    Approved,
    Rejected,
    Delegated,
    ChangeRequest,
    RequestUpdated,
    FillCertificate,
    CertificateApproved,
    CertificateRejected,
    OpinionExpressed
}
